if (!customElements.get('sticky-cta-banner')) {
  customElements.define(
    'sticky-cta-banner',
    class StickyCtaBanner extends HTMLElement {
      connectedCallback() {
        // The bar is rendered inside a section whose ancestors may trap
        // `position: fixed` (transform/contain wrappers) and constrain width.
        // Relocate to <body> so fixed positioning resolves against the viewport.
        // Moving re-triggers connectedCallback, which then runs setup parented
        // to <body>. Match the product-page sticky ATC bar's approach.
        if (this.parentNode !== document.body) {
          document.body.appendChild(this);
          return;
        }

        // The section's in-flow wrapper stays where it was rendered (right after
        // the banner) even though this bar moved to <body>. Its natural document
        // offset is our scroll trigger point.
        this.anchor = document.getElementById(
          'shopify-section-' + this.dataset.sectionId
        );
        if (!this.anchor) return;

        this.isVisible = false;
        this.ticking = false;
        this.measure();

        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.updateVisibility();
            this.ticking = false;
          });
        };
        this.onResize = () => {
          this.measure();
          this.updateVisibility();
        };

        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);
        // Media above the anchor may finish loading after first paint and shift
        // its offset; re-measure once everything has loaded.
        window.addEventListener('load', this.onResize, { once: true });
        this.updateVisibility();
      }

      measure() {
        // Sum offsetTop through the offsetParent chain for a stable document
        // offset (ignores any sticky paint offset on ancestors). Trigger once the
        // visitor has scrolled past the anchor's top edge — i.e. past the banner.
        let top = 0;
        let node = this.anchor;
        while (node) {
          top += node.offsetTop || 0;
          node = node.offsetParent;
        }
        this.triggerOffset = top;
      }

      updateVisibility() {
        const scrolled =
          window.pageYOffset || document.documentElement.scrollTop || 0;
        const visible = scrolled > this.triggerOffset;
        if (visible === this.isVisible) return;
        this.isVisible = visible;
        this.classList.toggle('is-visible', visible);
        this.setAttribute('aria-hidden', visible ? 'false' : 'true');
      }

      disconnectedCallback() {
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
        if (this.onResize) window.removeEventListener('resize', this.onResize);
      }
    }
  );
}
